import { angularFileUpload, IHttpService, IPromise, IRequestConfig, IRequestShortcutConfig } from 'angular';
import { environment } from '../../../../environments/environment';

export class ApiService {
  static $inject = [
    '$http',
    'Upload'
  ];

  constructor( private $http: IHttpService,
               private uploadService: angularFileUpload.IUploadService ) {
  }

  get<T=any>( url: string, config: IRequestShortcutConfig = {} ): IPromise<T> {
    return this.$http.get<T>(this.createUrl(url), config)
      .then(( res ) => res.data );
  }

  post<T=any>( url: string, data: any = {}, config: IRequestShortcutConfig = {} ): IPromise<T> {
    return this.$http.post<T>(this.createUrl(url), data, config)
      .then(( res ) => res.data);
  }

  patch<T=any>( url: string, data: any = {}, config: IRequestShortcutConfig = {} ): IPromise<T> {
    return this.$http.patch<T>(this.createUrl(url), data, config)
      .then(( res ) => res.data);
  }

  delete<T=any>( url: string, config: IRequestShortcutConfig = {} ): IPromise<T> {
    return this.$http.delete<T>(this.createUrl(url), config)
      .then(( res ) => res.data);
  }

  put<T=any>( url: string, data: any = {}, config: IRequestShortcutConfig = {} ): IPromise<T> {
    return this.$http.put<T>(this.createUrl(url), data, config)
      .then(( res ) => res.data);
  }

  request<T=any>( config: IRequestConfig ): IPromise<T> {
    config.url = this.createUrl(config.url);
    return this.$http<T>(config)
      .then(( res ) => res.data);
  }

  upload<T=any>( url: string, data: any ): angularFileUpload.IUploadPromise<T> {
    return this.uploadService.upload<T>({
      url: this.createUrl(url),
      method: 'POST',
      data
    });
  }

  private createUrl( url: string ): string {
    return `${environment.host}${url}`;
  }

  private createUploadUrl( url: string ): string {
    return `${environment.uploadsHost}${url}`;
  }


}



// WEBPACK FOOTER //
// ./app/core/services/api-service/api.service.ts